import React from "react";
import { Switch, Route } from 'react-router-dom';
import Stockroom from "./Stockroom";

export default function StockroomRouter() {
  return <Switch>
    <Route path="/stockroom" component={Stockroom} />
    <Route path="/" component={Stockroom} />
  </Switch>
}